import React, { useState } from 'react';

import { Accordion, Text } from '../../../../../ui-kit';















function OutputCreditsFooter({ footerStartAdornment, footerTotalValue }) {
  return (
    <div className="payment-section__footer">
      <div className="payment-section__footer-start-adornment">
        <Text className="payment-section__footer-start-adornment-text" noMargin>
          {footerStartAdornment}
        </Text>
      </div>
      <div className="payment-section__footer-spacer" />

      <div className="payment-section__footer-total-block">
        <Text className="payment-section__footer-total-value" noMargin>
          {footerTotalValue}
        </Text>
      </div>
    </div>);

}

function OutputsCreditDetails({
  title,
  children,
  footerStartAdornment,
  footerTotalValue,
  hasBottomDivider,
  isOpenedByDefault = true,
  initialOpenIndex,
  ghost,
  hideCreditsModification,
  addedCreditPerOutput,
  creativeServicesCredits = 0
}) {
  const openIndex = isOpenedByDefault ? 0 : -1;
  const [currentOpenedIndex, setCurrentOpenedIndex] = useState(openIndex);
  const getOpenIndex = (index) => setCurrentOpenedIndex(index);
  const isAccordionCollapsed = currentOpenedIndex !== 0;

  return (
    <div className="payment-summary-content__output-wrapper">
      <Accordion
        titles={{
          label: title || '',
          subtitle: !isAccordionCollapsed && hideCreditsModification ?

          <>
                <div className="payment-summary-content__output-wrapper__credits-used">
                  <Text>Production</Text>
                  <Text className="payment-summary-content__output-wrapper__credits-used__credits">
                    {`${addedCreditPerOutput} ${addedCreditPerOutput > 1 ? 'Credits' : 'Credit'}`}
                  </Text>
                </div>
                <div className="payment-summary-content__output-wrapper__credits-used">
                  <Text>Creative Services</Text>
                  <Text className="payment-summary-content__output-wrapper__credits-used__credits">
                    {`${creativeServicesCredits} ${creativeServicesCredits > 1 ? 'Credits' : 'Credit'}`}
                  </Text>
                </div>
              </> :
          null
        }}
        initialOpenIndex={isOpenedByDefault ? openIndex : initialOpenIndex}
        getOpenIndex={getOpenIndex}
        shouldPreventSelection={ghost}
        // subtitle={addedCreditPerOutput}
      >
        <div className="payment-section__body">
          {children &&
          <>
              <div className="payment-section__body-content">
                {children}
              </div>

              {hasBottomDivider ? <hr className="payment-section__body-divider" /> : null}
            </>}

        </div>
      </Accordion>

      <OutputCreditsFooter
        footerStartAdornment={footerStartAdornment}
        footerTotalValue={footerTotalValue} />

    </div>);

}

export default OutputsCreditDetails;